import React, { useMemo } from 'react';
import { NotecardEditorSelectWrapper } from '../notecard-editor-select-wrapper';
import { MAX_FONT_SIZE_PT, NOTECARD_EDITOR_STYLES_MAP } from '../constants';
import { getStyleValueForPrefix } from '../helpers';
import classes from './notecard-editor-select-font-size.scss';
import animationClasses from './notecard-editor-select-font-size-animation.scss';
const prefix = NOTECARD_EDITOR_STYLES_MAP.FONT_SIZE_PREFIX;
const DEFAULT_FONT_SIZE_PT = 11;
export const NotecardEditorSelectFontSize = ({
  selectionStyles,
  handleSelectStyleChange,
  isOpened,
  toggleOpened
}) => {
  const fontSizeValue = useMemo(() => {
    const styleValue = getStyleValueForPrefix(selectionStyles, prefix);
    return styleValue ? parseInt(styleValue) : null;
  }, [selectionStyles]);
  const handleChange = value => {
    const currentValue = fontSizeValue || DEFAULT_FONT_SIZE_PT;
    const newValue = currentValue + value;
    if (newValue > MAX_FONT_SIZE_PT || newValue < 1) {
      return;
    }
    handleSelectStyleChange(`${newValue}pt`, prefix);
  };
  const getFontSizeData = () => {
    if (fontSizeValue === null) {
      return {
        fontSizeLabel: 'Text size',
        fontSizeInputValue: DEFAULT_FONT_SIZE_PT
      };
    }
    return {
      fontSizeLabel: `${fontSizeValue}pt`,
      fontSizeInputValue: fontSizeValue
    };
  };
  const {
    fontSizeLabel,
    fontSizeInputValue
  } = getFontSizeData();
  const icon = /*#__PURE__*/React.createElement("span", {
    className: classes.textIcon
  }, "T");
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectWrapper, {
    isOpened: isOpened,
    animationClasses: animationClasses,
    name: fontSizeLabel,
    icon: icon,
    toggleOpened: toggleOpened
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsContainer
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.fontSizeButton,
    onClick: () => handleChange(-1)
  }, "-"), /*#__PURE__*/React.createElement("div", {
    className: classes.fontSizeValue
  }, fontSizeInputValue), /*#__PURE__*/React.createElement("button", {
    className: classes.fontSizeButton,
    onClick: () => handleChange(1)
  }, "+")))));
};